<template>
  <div class="titleModule">
    <section :style="containerHeight">
      <div class="box alignItem">
        <p class="titleFont">{{ title }}</p>
      </div>
      <div class="more alignItem">
        <p v-if="moreStatus" @click="moreEvent()">更多<span>></span></p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    title: '',
    containerHeight: {}, // 容器
    moreStatus: false
  },
  data() {
    return {};
  },
  methods: {
    moreEvent() {
      this.$emit('previewMoreReturn');
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.titleModule {
  background: url('../../../static/img/visual/title-bg.png') left center no-repeat;
  background-size: auto 100%;
  section {
    display: flex;
    padding: 0 0.65vw 0 1.5vw;
    min-height: 1.84vw; // 35
    height: 1.84vw;
    max-height: 2.315vw; // 44
    font-size: 0.8vw;
    color: white;
    .box {
      flex: 1;
      font-size: 1vw;
      line-height: 0.8vw;
      height: 100%;
      p {
        font-family: 'titleFont';
        letter-spacing: 0.1vw;
      }
    }
    .more {
      color: #ff9a05;
      font-size: 0.75vw;
      line-height: 0.75vw;
      cursor: pointer;
    }
  }
}

.alignItem {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  //   -webkit-justify-content: center;
  //   justify-content: center;
  //   -webkit-justify-content: center;
  //align-items:center;
}
</style>



// WEBPACK FOOTER //
// src/views/businessModule/titleModule.vue